export default class  {
    constructor(selector, settings) {
        this.el = document.querySelector(selector);
        this.eventList = {};
        this.tl = new TimelineMax();
        this.refsList = this.el.querySelectorAll('[data-ref]');
        this.refs = {};
        this.isOpen = true;

        if (this.el) this.generateElementsByRef();

    }

    show() {
        if(this.isOpen) return

        this.isOpen = true;
        this.tl.clear();
        this.tl.to(this.el, 0.4, {opacity: 1, pointerEvents: 'auto'})
    }

    hide() {
        if(!this.isOpen) return

        this.isOpen = false;
        this.tl.clear();
        this.tl.to(this.el, 0.4, {opacity: 0, pointerEvents: 'none'})
    }

    generateElementsByRef() {
        if(!this.refsList.length) return

        Array.from(this.refsList).forEach( ref => {
            let key = ref.getAttribute('data-ref');

            if(!key) return

            this.refs[key] = ref;
        })
    }

    registerEvent(eventName) {
        this.eventList[eventName] = {
            subscribers: [],
            dispatch: function(...arr) {
                if(!this.subscribers.length) return
                this.subscribers.forEach( subscriber => {
                    subscriber(...arr);
                })
            }
        }

    }

    emit(eventName, ...arr) {
        if(!this.eventList[eventName]) {
            console.log('There is no such event for subscribe. You need to register it');
            return;
        }
        this.eventList[eventName].dispatch(...arr)
    }

    on(eventName, cb) {
        if(!cb) return

        if(!this.eventList[eventName]) this.registerEvent(eventName);

        this.eventList[eventName].subscribers.push(cb)
    }
}
